<script>
	import { goto } from '$app/navigation';
	import { page } from '$app/stores';
	import { basketListnew } from '$lib/store/newbasket';
	import { lang } from '$lib/translations/bottommenu';
	import { clickOutside } from '$lib/utils/click_outside';
	import BasketPage from './BasketPage.svelte';
	import FavoritesPage from './FavoritesPage.svelte';
	import Search from './Search.svelte';
	let OpenSearch = false;
	let OpenFavorites = false;
	let OpenBasket = false;
	let openMenuProfile = false;
	async function LogoutUser() {
		let url = `/auth/logout`;
		const res = await fetch(url);
		setTimeout(() => {
			window.location.href = $page.url.pathname;
		}, 200);
	}
</script>

{#if OpenSearch}
	<Search bind:OpenSearch />
{/if}

{#if OpenFavorites}
	<FavoritesPage bind:OpenFavorites />
{/if}

{#if OpenBasket}
	<BasketPage bind:OpenBasket />
{/if}
<div
	style="background: #1b1b1b;"
	class="px-1 shadow-lg fixed bottom-0 left-0 w-full z-40 rounded-tl-2xl rounded-tr-2xl"
>
	<div class="flex justify-between items-center w-full">
		<div class="flex-1 group">
			<a
				href="/"
				class="flex items-end justify-center text-center mx-auto px-4 pt-2 w-full text-gray-400 group-hover:text-gray-400"
			>
				<span class="flex flex-col justify-center items-center px-1 pt-1 pb-1">
					<svg
						class="w-6 h-6 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-red-500 dark:group-hover:text-blue-500"
						fill="currentColor"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							d="M10.707 2.293a1 1 0 00-1.414 0l-7 7a1 1 0 001.414 1.414L4 10.414V17a1 1 0 001 1h2a1 1 0 001-1v-2a1 1 0 011-1h2a1 1 0 011 1v2a1 1 0 001 1h2a1 1 0 001-1v-6.586l.293.293a1 1 0 001.414-1.414l-7-7z"
						/>
					</svg>
					<span class="block text-xs pb-2">{lang[$page.data.host]['home']}</span>
					<span class="block w-5 mx-auto h-1 group-hover:bg-red-500 rounded-full" />
				</span>
			</a>
		</div>
		<div class="flex-1 group">
			<button
				on:click={() => (OpenSearch = true)}
				class="flex items-end justify-center text-center mx-auto px-4 pt-2 w-full text-gray-400 group-hover:text-gray-400"
			>
				<span class="block px-1 pt-1 pb-1">
					<svg
						class="w-6 h-6 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-red-500 dark:group-hover:text-blue-500"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 20 20"
						><path
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
							class="s-MMN3rRE-BmEv"
						/></svg
					>
					<span class="block text-xs pb-2">{lang[$page.data.host]['search']}</span>
					<span class="block w-5 mx-auto h-1 group-hover:bg-red-500 rounded-full" />
				</span>
			</button>
		</div>
		<!-- <div class="flex-1 group">
			<button
				on:click={() => {
					OpenFavorites = true;
				}}
				class="flex items-end justify-center text-center mx-auto px-4 pt-2 w-full text-gray-400 group-hover:text-gray-400"
			>
				<span class="flex flex-col items-center px-1 pt-1 pb-1">
					<svg
						class="w-6 h-6 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-red-500 dark:group-hover:text-blue-500"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						><path
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M4.318 6.318a4.5 4.5 0 000 6.364L12 20.364l7.682-7.682a4.5 4.5 0 00-6.364-6.364L12 7.636l-1.318-1.318a4.5 4.5 0 00-6.364 0z"
							class="s-MMN3rRE-BmEv"
						/>
					</svg>

					<span class="block text-xs pb-2">{lang[$page.data.host]['favorite']}</span>
					<span class="block w-5 mx-auto h-1 group-hover:bg-red-500 rounded-full" />
				</span>
			</button>
		</div> -->
		<div class="flex-1 group">
			<button
				on:click={() => (OpenBasket = true)}
				class="flex items-end justify-center text-center mx-auto px-4 pt-2 w-full text-gray-400 group-hover:text-gray-400"
			>
				<span class="block relative px-1 pt-1 pb-1">
					<!-- <div
                    class="absolute -top-2 right-0 text-[8px] inline-flex items-center justify-center w-4 h-4 font-bold text-white bg-red-500 rounded-full"
                >
                    {$basketListnew.order_items.length}
                </div> -->
					<span
						class="absolute -top-1 left-4 rounded-full bg-red-500 p-0.5 px-2 text-sm text-red-50"
						>{$basketListnew.order_items.length}</span
					>
					<svg
						class="w-6 h-6 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-red-500 dark:group-hover:text-blue-500"
						aria-hidden="true"
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 20 20"
					>
						<path
							stroke="currentColor"
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M2.25 3h1.386c.51 0 .955.343 1.087.835l.383 1.437M7.5 14.25a3 3 0 00-3 3h15.75m-12.75-3h11.218c1.121-2.3 2.1-4.684 2.924-7.138a60.114 60.114 0 00-16.536-1.84M7.5 14.25L5.106 5.272M6 20.25a.75.75 0 11-1.5 0 .75.75 0 011.5 0zm12.75 0a.75.75 0 11-1.5 0 .75.75 0 011.5 0z"
						/>
					</svg>
					<span class="block text-xs pb-2">{lang[$page.data.host]['basket']}</span>
					<span class="block w-5 mx-auto h-1 group-hover:bg-red-500 rounded-full" />
				</span>
			</button>
		</div>

		<div class="flex-1 group">
			<button
				use:clickOutside
				on:outclick={() => (openMenuProfile = false)}
				on:click={() => {
					if (!$page.data.user) {
						goto('/auth/sign-in');
					} else {
						openMenuProfile = !openMenuProfile;
					}
				}}
				class="flex items-end relative justify-center text-center mx-auto px-4 pt-2 w-full text-gray-400 group-hover:text-gray-400"
			>
				<span class=" px-1 flex flex-col justify-center items-center pt-1 pb-1">
					<svg
						class="w-6 h-6 mb-1 text-gray-500 dark:text-gray-400 group-hover:text-red-500 dark:group-hover:text-blue-500"
						fill="currentColor"
						viewBox="0 0 20 20"
						xmlns="http://www.w3.org/2000/svg"
						aria-hidden="true"
					>
						<path
							clip-rule="evenodd"
							fill-rule="evenodd"
							d="M18 10a8 8 0 11-16 0 8 8 0 0116 0zm-6-3a2 2 0 11-4 0 2 2 0 014 0zm-2 4a5 5 0 00-4.546 2.916A5.986 5.986 0 0010 16a5.986 5.986 0 004.546-2.084A5 5 0 0010 11z"
						/>
					</svg>
					<span class="block text-xs pb-2">{lang[$page.data.host]['profile']}</span>
					<span class="block w-5 mx-auto h-1 group-hover:bg-red-500 rounded-full" />
				</span>
				{#if openMenuProfile}
					<div
						class="absolute -right-2 bottom-16 z-10 mt-2 w-48 origin-top-right rounded-md bg-white py-1 shadow-lg ring-1 ring-black ring-opacity-5 focus:outline-none"
						role="menu"
						aria-orientation="vertical"
						aria-labelledby="user-menu-button"
						tabindex="-1"
					>
						<!-- Active: "bg-gray-100", Not Active: "" -->
						<a
							href="/profile"
							class="block px-4 py-2 text-sm text-gray-700"
							role="menuitem"
							tabindex="-1"
							id="user-menu-item-0">Профиль</a
						>
						<!-- svelte-ignore missing-declaration -->
						<!-- svelte-ignore a11y-click-events-have-key-events -->
						<span
							on:click={() => {
								LogoutUser();
							}}
							class="block px-4 py-2 text-sm text-gray-700"
							role="menuitem"
							tabindex="-1"
							id="user-menu-item-1">Выйти</span
						>
					</div>
				{/if}
			</button>
		</div>
	</div>
</div>
